/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderFormStateSchema,
  BuilderUserContext, FormRootSchema,
  FormState, FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission, PRIVILEGED_EP_SYS_VARS_ACCOUNTING } from '@gh/builder-shared-data';
import { FormMode, getControlValue, markControlAsDirty, setControlValue } from '@gh/core-ui';
import { AccountingAccount, SystemVarsAccountingReceivableModel } from '../../../resources';

@Injectable()
export class SystemVarsAccountingReceivablesFormService extends FormState<SystemVarsAccountingReceivableModel> {
  constructor(
    schemaFactory: BuilderFormSchemaFactory,
    private userContext: BuilderUserContext,
  ) {
    super(schemaFactory);
  }

  getAccount(fieldName: string): Maybe<AccountingAccount> {
    return getControlValue(this.group, fieldName);
  }

  setAccount(fieldName: string, item: AccountingAccount): void {
    setControlValue(this.group, fieldName, item);
    markControlAsDirty(this.group, fieldName);
  }

  protected buildSchema(_: SystemVarsAccountingReceivableModel, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Accounting.EDIT)
      ? FormMode.EditMode
      : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      privilegedEntryPoints: [PRIVILEGED_EP_SYS_VARS_ACCOUNTING],
      optimisticLock: true,
      children: {
        incomeAccountContractJob: { required: true },
        incomeAccountSpecJob: { required: true },
        wipAssetAccount: { required: true, privileged: PRIVILEGED_EP_SYS_VARS_ACCOUNTING },
        wipOpening: { required: true, privileged: PRIVILEGED_EP_SYS_VARS_ACCOUNTING },
        wipClosing: { required: true, privileged: PRIVILEGED_EP_SYS_VARS_ACCOUNTING },
      },
    });
  }
}
